import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AdminContext = createContext(null);
export const useAdmin = () => useContext(AdminContext);

export function AdminProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null checking, false anon, object authed

  useEffect(() => {
    if (!localStorage.getItem("bg_admin_token")) { setAdmin(false); return; }
    api.get("/admin/auth/me").then((r) => setAdmin(r.data)).catch(() => { localStorage.removeItem("bg_admin_token"); setAdmin(false); });
  }, []);

  const signIn = useCallback((data) => { localStorage.setItem("bg_admin_token", data.access_token); setAdmin({ email: data.email }); }, []);
  const signOut = useCallback(() => { localStorage.removeItem("bg_admin_token"); setAdmin(false); }, []);

  return <AdminContext.Provider value={{ admin, signIn, signOut }}>{children}</AdminContext.Provider>;
}
